import type { ReactNode } from 'react';
import { ChevronDown, ChevronUp } from 'react-feather';
import styled from '@emotion/styled';

// Port of apps/frontend's brand-insights/components/Chat/ResponsePane.tsx (ChatResponsePane) --
// despite living in that folder, it's a plain collapsible panel with no actual chat-sidebar/
// brand-insights dependency, so it's ported directly rather than pulled in from there. Shared by
// Grid.tsx's quote-widget sources panel and the shared TranscriptSourcesPane so every dashboard's
// "Sources" toggle looks and behaves identically.

type Props = {
  title: string;
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
};

export const ResponsePane = ({ title, open, onToggle, children }: Props) => (
  <PaneRoot>
    <PaneHeader onClick={onToggle} type="button">
      <PaneHeaderTitle>{title}</PaneHeaderTitle>
      {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
    </PaneHeader>
    {open && children}
  </PaneRoot>
);

ResponsePane.displayName = 'PatientJourneyDashboard.ResponsePane';

const PaneRoot = styled.div`
  margin-top: 15px;
  border-top: 2px solid ${(props) => props.theme.palette.gray.light2};
  padding-top: 10px;
`;

const PaneHeader = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  color: ${(props) => props.theme.palette.gray.dark1};
`;

const PaneHeaderTitle = styled.div`
  font-family: ${(props) => props.theme.fonts.semiBold};
  font-size: 16px;
  color: ${(props) => props.theme.palette.black.main};
`;
